export default __webpack_public_path__ + "static/data-vis-text-charts-do-f833f61676755e45c8be6de3adf23882.png";